import gql from 'graphql-tag';
import { Good360FullFragment } from '../fragments/Good360FullFragment';

export const Good360DetailQuery = gql`
	query Good360DetailQuery($id: ID!) {
		entity: node(id: $id) {
			...Good360FullFragment
		}
	}
	${Good360FullFragment}
`;